"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.createSnapshot = void 0;

var copyElementStyle = function copyElementStyle(element, styleAttrsToCopy) {
  var styleCopy = {};

  if (styleAttrsToCopy.length !== 0) {
    var computedStyle = getComputedStyle(element);
    styleAttrsToCopy.forEach(function (attr) {
      return styleCopy[attr] = computedStyle[attr];
    });
  }

  return styleCopy;
};

var createSnapshot = function createSnapshot(element, styleAttrsToCopy) {
  var rect = element.getBoundingClientRect();
  var style = copyElementStyle(element, styleAttrsToCopy);
  return {
    rect: rect,
    style: style
  };
};

exports.createSnapshot = createSnapshot;
var _default = createSnapshot;
exports["default"] = _default;